export default __webpack_public_path__ + "assets/chevron-left.da3e19bd.svg";